import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../hooks/useNotifications';
import { FaMapMarkerAlt, FaHeadset, FaBell } from 'react-icons/fa';
import toast from 'react-hot-toast';

const MobileHeader = () => {
  const { user, isAuthenticated } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOnline, setIsOnline] = useState(false); // You can sync this with backend later

  // Don't show header on login, register, or admin pages
  const hideHeader = 
    !isAuthenticated ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/register') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/track/');

  if (hideHeader) {
    return null;
  }

  const handleToggleOnline = () => {
    const newStatus = !isOnline;
    setIsOnline(newStatus);
    // TODO: Sync with backend API to update rider availability
    toast.success(newStatus ? 'You are now online' : 'You are now offline', {
      duration: 2000
    });
  };

  const handleNotificationsClick = () => {
    navigate('/notifications');
  };

  const handleLocationClick = () => {
    // TODO: Open location settings or map
    toast.info('Location feature coming soon');
  };

  const handleSupportClick = () => {
    // TODO: Open support/help
    navigate('/help');
  };

  return (
    <header className="bg-gradient-to-r from-blue-600 to-blue-800 text-white sticky top-0 z-40 md:hidden">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left: Online/Offline Toggle */}
        <div className="flex items-center space-x-2">
          <button
            onClick={handleToggleOnline}
            className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-800"
            style={{ backgroundColor: isOnline ? '#10b981' : '#6b7280' }}
            aria-label="Toggle online status"
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                isOnline ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <span className={`text-sm font-medium px-3 py-1 rounded-full ${
            isOnline ? 'bg-green-500' : 'bg-gray-500'
          }`}>
            {isOnline ? 'Online' : 'Offline'}
          </span>
        </div>

        {/* Right: Action Icons */}
        <div className="flex items-center space-x-3">
          {/* Notifications */}
          <button
            onClick={handleNotificationsClick}
            className="relative p-2 rounded-full hover:bg-blue-700 transition-colors"
            aria-label="Notifications"
          >
            <FaBell className="text-xl" />
            {unreadCount > 0 && (
              <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          {/* Location */}
          <button
            onClick={handleLocationClick}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors"
            aria-label="Location"
          >
            <FaMapMarkerAlt className="text-xl" />
          </button>

          {/* Support */}
          <button
            onClick={handleSupportClick}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors"
            aria-label="Support"
          >
            <FaHeadset className="text-xl" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;

